import moment from 'moment';

export default function commentCreatedAt(createdAt) {
  return moment(new Date(createdAt)).format('DD.MM.YY HH:mm:ss');
}
